import React from 'react'

export default function NotFound() {
  document.title = "Flight"
  
  return (
    <h1>SORRY, NOT FOUND !</h1>
  )
}
